import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const getSupportPlanLogsService = async (userId) => {
  const response = await Axios.get(
    `${API_URL}/CarePlanWizardDetail/get-user-support-plan-logs/${userId}`,
  );
  return response.data;
};

export { getSupportPlanLogsService };
